import React from "react";

import Explore1 from "../imgs/explore/explore1.svg";
import Explore2 from "../imgs/explore/explore2.svg";

import Spot from "../imgs/explore/spot.svg";
import Showcase from "../imgs/explore/showcase.svg";
import Earn from "../imgs/explore/earn.svg";

import Card1 from "../imgs/explore/card1.png";
import Card2 from "../imgs/explore/card2.png";
import { useNavigate } from "react-router-dom";

const Explore = () => {
  const navigate = useNavigate();

  return (
    <section
      id="hiw"
      className="md:space-x-4 space-y-4 md:space-y-0 rounded-2xl bg-white pt-10 pb-20 px-5 md:px-8 lg:px-20 relative explore"
      style={{ marginTop: -20, marginBottom: -20 }}
    >
      <div className="flex flex-col lg:flex-row space-y-4 md:space-y-0 rounded-xl bg-white py-10">
        <div className="flex-1 flex flex-col justify-center lg:justify-start p-6">
          <h1 className="text-center lg:text-start text-4xl lg:text-5xl font-bold mb-5">
            Explore Your Interests in Creative Arts and Tech
          </h1>
          <a
            href="https://app.hallimo.com/register"
            className="w-auto self-center lg:self-start px-8 py-3 bg-[#3BF5CA] border text-[#052035] border-[#052035]  rounded-md"
          >
            Get Started
          </a>

          <div className="flex items-center mt-16 px-0 md:px-20 lg:px-0">
            <img src={Spot} className="mr-5" height={32} width={32} />
            <div>
              <p className="font-semibold text-[#052035]">
                Spot Topics of Interest
              </p>
              <p className="text-[#374D5D] text-sm">
                Find engaging challenges tailored to your passions.
              </p>
            </div>
          </div>

          <div className="flex items-center mt-10 px-0 md:px-20 lg:px-0">
            <img src={Showcase} className="mr-5" height={32} width={32} />
            <div>
              <p className="font-semibold text-[#052035]">
                Showcase Your Knowledge and Skills
              </p>
              <p className="text-[#374D5D] text-sm">
                Test what you know and prove your expertise
              </p>
            </div>
          </div>

          <div className="flex items-center mt-10 px-0 md:px-20 lg:px-0">
            <img src={Earn} className="mr-5" height={32} width={32} />
            <div>
              <p className="font-semibold text-[#052035]">
                Earn Points, Redeem Rewards
              </p>
              <p className="text-[#374D5D] text-sm">
                Turn your achievements into rewards you can use.
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row items-start justify-between flex-1 bg-[#E6E9EB] rounded-xl p-6 space-y-3 lg:space-y-0">
          <img src={Explore1} className="w-[100%] lg:w-[48%]" />
          <img src={Explore2} className="w-[100%] lg:w-[48%]" />
        </div>
      </div>

      <div className="flex flex-col lg:flex-row lg:items-center pt-20">
        <img
          src={Card1}
          className="w-full md:w-[560px] h-[200px] md:h-[328px] lg:mr-10"
        />
        <div>
          <h1 className="text-3xl lg:text-4xl font-bold mt-6 lg:mt-0 mb-2">
            Join our referral program
          </h1>
          <p className="text-[#374D5D] mb-7">
            Earn points for inviting your friends and family
          </p>
          <a
            href="https://app.hallimo.com/register"
            className="w-auto self-center lg:self-start px-8 py-3 bg-[#3BF5CA] border text-[#052035] border-[#052035]  rounded-md"
          >
            Get Started
          </a>
        </div>
      </div>

      <div className="flex justify-end">
        <div className="flex flex-col lg:flex-row lg:items-center pt-20">
          <img
            src={Card2}
            className="w-full md:w-[560px] h-[200px] md:h-[328px] lg:mr-10"
          />
          <div className="flex flex-col items-end lg:items-start">
            <h1 className="text-3xl lg:text-4xl font-bold mt-6 lg:mt-0 text-right lg:text-left mb-2">
              Support our mission
            </h1>
            <p className="text-[#374D5D] mb-5 text-right lg:text-left">
              Join our Patron program
            </p>
            <button
              onClick={() => navigate("/patrons")}
              className="w-auto self-end lg:self-start px-8 py-3 bg-[#3BF5CA] border text-[#052035] border-[#052035]  rounded-md"
            >
              Become A Patron
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Explore;
